import { render, staticRenderFns } from "./f2fpay.vue?vue&type=template&id=5fa8f108&scoped=true&"
import script from "./f2fpay.vue?vue&type=script&lang=js&"
export * from "./f2fpay.vue?vue&type=script&lang=js&"
import style0 from "./f2fpay.vue?vue&type=style&index=0&id=5fa8f108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8f108",
  null
  
)

export default component.exports